module.exports = __webpack_public_path__ + "img/mov.4011acbb.svg";